
import Button from "@/components/base/Button"
import DateTimeCard from "@/components/base/card/DateTimeCard"
import ImageUploader from "@/components/base/image/ImageUploader"
import TextArea from "@/components/base/input/TextArea"
import rules from "@/mixins/rules"
import dates from "@/mixins/dates"

export default {
    name: "EventEditor",
    components: {
        TextArea,
        ImageUploader,
        Button,
        DateTimeCard,
    },
    mixins: [rules, dates],
    emits: ["exit", "save"],
    props: {
        /** Optional: Event object for editing it */
        event: {
            type: Object,
            default: () => ({}),
        },
        noCancelBtn: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        title: "",
        description: "",
        mainImage: {},
        startDate: "",
        startTime: "",
        editing: false,
    }),
    computed: {
        isImageUploading() {
            return this.mainImage?.request?.state === "pending"
        },
    },
    watch: {
        event(newVal) {
            this.setEvent(newVal)
        },
    },
    mounted() {
        this.setEvent(this.event)
    },
    methods: {
        save() {
            let date = new Date(this.startDate)
            this.addTime(date, this.startTime)
            if (
                this.$refs.editorForm.validate() &&
                this.$refs.dateTime.validate()
            ) {
                this.$emit("save", {
                    title: this.title,
                    text: this.description,
                    image_id: this.mainImage?.id,
                    start_at: date,
                })
            }
        },
        setEvent(event) {
            this.title = event?.title
            this.description = event?.text
            this.mainImage = event?.image
            if (event) {
                this.editing = true
                this.startDate = event.start_at
                this.startTime = this.toTime(event.start_at)
            } else {
                this.editing = false
                this.startDate = null
                this.startTime = null
            }
        },
        exit() {
            this.$emit("exit", this.event?.slug)
        },
    },
}
